var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "msg-subscr-msanage" }, [
      _c("div", { staticClass: "hint block mb10" }, [
        _c("div", { staticClass: "title" }, [_vm._v("温馨提示")]),
        _vm._v(" "),
        _c("p", [_vm._v("逐条检查：一条一条的检查，因数据较多花费时间较长")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "hint block mb10" }, [
        _c("p", [
          _vm._v("逐条检查导入：一条一条的检查并导入，因数据较多花费时间较长")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "hint block" }, [
        _c("p", [_vm._v("导入excel文件的单元格格式推荐使用常规或文本")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "message-body mt10" }, [
        _c("ul", { staticClass: "native-table" }, [
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-th",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("列名")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-th", staticStyle: { width: "120px" } },
              [_vm._v("是否必填")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-th",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("其他要求")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-th" }, [_vm._v("不符合要求的结果")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("机构名称")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据模板生成，不可以修改")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("地址信息")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据模板生成，不可以修改")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("详细地址")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据模板生成，不可以修改")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("联系人")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据模板生成，不可以修改")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("联系电话")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据模板生成，不可以修改")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("供应商")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据模板生成，不可以修改")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("商品名称")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据模板生成，不可以修改")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("分类")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据模板生成，不可以修改")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("品牌")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据模板生成，不可以修改")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("组装件")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("是否作为组装件")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("含税价(元)")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c("div", {
              staticClass: "table-td",
              staticStyle: { "text-align": "left" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("税率(%)")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c("div", {
              staticClass: "table-td",
              staticStyle: { "text-align": "left" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("未税价(元)")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据价格-税率计算，无需输入")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("配货数量")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("可在系统中进行选择以系统的为准，最小为0、正整数")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("单位")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("根据模板生成，不可以修改")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("说明")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("可在系统中进行选择以系统的为准")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21d0a71f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21d0a71f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/AllocFormFormatExpl.vue
// module id = 2974
// module chunks = 0